import PersonalShiftUpdates from './personal-shift-updates'

export default PersonalShiftUpdates
